





import { Component, Vue, Prop } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'

@Component
export default class AuthAreaLink extends Vue {
  // -------------------------------------------------------------------------------------------------------------------
  // Props
  @Prop() private authAreaUrl!: string

  // -------------------------------------------------------------------------------------------------------------------
  // computed
  get isLogin(): boolean {
    return membershipState.isLogin
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods
  public async checkSignin(url: string): Promise<void> {
    // SignInチェック後にURLにアクセスするかSSOに飛ぶか
    // Accessページ記載のリンクをクリックしたときはpathnameしか渡されないが、SSOではフルパスが必要なためドメインを追加している。
    if (url.indexOf(drupalSettings.path.baseUrl) === 0) {
      url = window.location.origin + url
    }

    membershipState.addRedirectUrl(url)
    await membershipState.checkLoginAccessHtml()
  }
}
